import { onBeforeMount, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';
/**
 * 关闭页签
 * @param close
 * @param next
 */
export function closePage(close, next) {
  window.dispatchEvent(new CustomEvent('page:close', {
    detail: {
      close: close,
      next: next
    }
  }));
}
/**
 * 刷新页签
 * @param route
 */
export function refreshPage(route) {
  window.dispatchEvent(new CustomEvent('page:refresh', {
    detail: {
      route: route
    }
  }));
}
/**
 * 配置页签位置、标题等
 * @param route
 * @param options
 */
export function configPage(route, options) {
  window.dispatchEvent(new CustomEvent('page:config', {
    detail: {
      route: route,
      options: options
    }
  }));
}
/**
 * 设置页签加载状态
 * @param route
 * @param options
 */
export function setPageLoading(route, loading) {
  var router = useRouter();
  var _route = router.resolve(route);
  if (_route && _route.meta) {
    _route.meta.loading = loading;
  }
  window.dispatchEvent(new CustomEvent('page:loading', {
    detail: {
      route: route,
      loading: loading
    }
  }));
}
/**
 * 关闭除指定页签以外的其他页签
 * @param route
 */
export function closeOtherPages(route) {
  window.dispatchEvent(new CustomEvent('page:closeOthers', {
    detail: {
      route: route
    }
  }));
}
/**
 * 关闭全部页签
 */
export function closeAllPages() {
  window.dispatchEvent(new CustomEvent('page:closeAll', {
    detail: {}
  }));
}
window['clearTabs'] = [];
export function clearPage(fullPath) {
  window['clearTabs'].push(fullPath);
}
export function onPageChange(listener) {
  onBeforeMount(function () {
    window.addEventListener('page:change', listener);
  });
  onBeforeUnmount(function () {
    window.addEventListener('page:change', listener);
  });
}